import { Avatar } from "@chakra-ui/react";

type ProfileIconProps = {
  pictureUrl?: string;
  size?: string;
};
export const ProfileIcon: React.FC<ProfileIconProps> = ({ pictureUrl, size='32px' }) => {
  return <Avatar src={pictureUrl} w={size} h={size} />
}